const IS_STAGING_OR_LOCAL = !!(
    // In vitest, window may not be defined, we still treat that as staging
    (
        !globalThis.window ||
        window.location.hostname.match(/studio-staging(\d*)?\.softr\.io$/) ||
        window.location.hostname.match(/preview\.staging(\d*)?\.softr\.app$/) ||
        window.location.hostname.match(/localhost/)
    )
);

export function isStagingOrLocal(): boolean {
    return IS_STAGING_OR_LOCAL;
}
